import './news.scss';
import 'swiper/scss';
import Swiper, { Grid, Navigation } from 'swiper';

class News {
    constructor ($element, options) {
        this.$news = $element;
        const defaults = {
            initAttr: 'data-newsroom'
        };

        this.settings = Object.assign({}, defaults, options);
        this.news = null;
        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        this.initialize();
    }

    initialize () {
        this.checkSize();

        window.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
            }
        }
    }

    initSlider () {
        this.news = new Swiper(this.$news, {
            modules: [Navigation, Grid],
            slidesPerView: 'auto',
            on: {
                init: function (swiper) {
                    console.log('swiper initialized', swiper);
                }
            }
        });
        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.news !== 'undefined' && this.news !== null) {
            this.news.destroy();
            this.sliderActive = false;
        }
    }
}

export { News };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$news = $context.querySelectorAll('[data-newsroom="root"]');

        for (let i = 0; i < $$news.length; i++) {
            const $news = $$news[i];
            $news.API = new News($news);
        }
    }
});
